import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { TripEconomicCreationRequest, TripEconomicData, TripEconomicEditRequest, TripEconomicGenerationResponse, TripEconomicSearchFilter } from "../../models/trip-economics.model";
import { TripData, TripEditRequest } from "../../models";

export const tripEconomicsGenerationRequest = createAction(
        '[TripEconomic] TripEconomic generation request', props<{ tripId: number }>());

export const tripEconomicsGenerationSuccess = createAction(
        '[TripEconomic] TripEconomic generation success', props<{ generatedTripEconomicsResponse: TripEconomicGenerationResponse }>());

export const tripEconomicsGenerationFail = createAction(
        '[TripEconomic] TripEconomic generation fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const tripEconomicsReGenerationRequest = createAction(
        '[TripEconomic] TripEconomic re-generation request', props<{ tripData: TripEditRequest }>());

export const tripEconomicsReGenerationSuccess = createAction(
        '[TripEconomic] TripEconomic re-generation success', props<{ generatedTripEconomicsResponse: TripEconomicGenerationResponse }>());

export const tripEconomicsReGenerationFail = createAction(
        '[TripEconomic] TripEconomic re-generation fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());


export const tripEconomicCreationRequest = createAction(
        '[TripEconomic] TripEconomic creation request', props<{ tripEconomicCreationRequest: TripEconomicCreationRequest }>());

export const tripEconomicCreationSuccess = createAction(
        '[TripEconomic] TripEconomic creation success', props<{ createdTripEconomic: TripEconomicData }>());

export const tripEconomicCreationFail = createAction(
        '[TripEconomic] TripEconomic creation fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const tripEconomicEdit = createAction(
        '[TripEconomic] TripEconomic edit', props<{ tripEconomicToEdit: TripEconomicData }>());

export const tripEconomicCopy = createAction(
        '[TripEconomic] TripEconomic copy', props<{ tripEconomicToCopy: TripEconomicData }>());

export const tripEconomicEditSave = createAction(
        '[TripEconomic] TripEconomic edit save', props<{ tripEconomicToEdit: TripEconomicEditRequest }>());

export const tripEconomicEditSaveSuccess = createAction(
        '[TripEconomic] TripEconomic edit save success', props<{ editedTripEconomic: TripEconomicData }>());

export const tripEconomicEditSaveFail = createAction(
        '[TripEconomic] TripEconomic edit fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const tripEconomicView = createAction(
        '[TripEconomic] TripEconomic view', props<{ tripEconomicToView: TripEconomicData }>());

export const tripEconomicSearchRequest = createAction(
        '[TripEconomic] TripEconomic search request', props<{ searchFilter: TripEconomicSearchFilter }>());

export const tripEconomicSearchAllRequest = createAction(
        '[TripEconomic] TripEconomic search all request');

export const tripEconomicSearchSuccess = createAction(
        '[TripEconomic] TripEconomic search success', props<{ searchResult: TripEconomicData[] }>());

export const tripEconomicSearchDataReset = createAction(
        '[TripEconomic] TripEconomic search data reset');

export const tripEconomicSearchFail = createAction(
        '[TripEconomic] TripEconomic search fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const tripEconomicDeleteRequest = createAction(
        '[TripEconomic] TripEconomic delete request', props<{ tripEconomicId: number }>());

export const tripEconomicDeleteSuccess = createAction(
        '[TripEconomic] TripEconomic delete success', props<{ tripEconomicId: number }>());

export const tripEconomicDeleteFail = createAction(
        '[TripEconomic] TripEconomic delete fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const tripEconomicDeleteByTripIdRequest = createAction(
        '[TripEconomic] TripEconomic delete by trip id request', props<{ tripId: number }>());

export const tripEconomicDeleteByTripIdSuccess = createAction(
        '[TripEconomic] TripEconomic delete by trip id success', props<{ tripId: number }>());

export const tripEconomicDeleteByTripIdFail = createAction(
        '[TripEconomic] TripEconomic delete by trip id fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const tripBudgetViewRequest = createAction(
        '[TripEconomic] TripBudget view request', props<{ tripId: number }>());

export const tripBudgetViewFail = createAction(
        '[TripEconomic] TripBudget view fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());